import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Stack, Button, Box, CircularProgress} from 'views/components';

import {Translate} from 'views/module';

import MessageFeedBox from './messages/MessageFeedBox';
import LogFeedBox from './logs/LogFeedBox';

{/* List of Client messages and Logs associated with the Client */}
const CorrespondanceFeed = (props) => {
  // Comments to display on client

  const {
    clientRn,

    // props for MessageFeedBox
    clientMessages: messages,
    clientLogs,

    clientMessagesLoading,
    clientMessagesLastEvaluatedKey,

    clientLogsLastEvaluatedKey,
    clientLogsLoading,

    sortDir,
    corType,
    clientBackend,
  } = props;

  const loadMoreMessages = () => {
    if (clientMessagesLoading && !clientMessagesLoading) {
      clientBackend.load.loadMessages(clientRn, clientMessagesLoading);
    }
    if (clientLogsLastEvaluatedKey && !clientLogsLoading) {
      clientBackend.load.loadLogs(clientRn, clientLogsLastEvaluatedKey);
    }
  };

  const messagesToDisplayCaluclator = React.useCallback(() => {
    const messagesFilter = Object.values(messages)
        .filter((message) => {
          return corType[message.messageType];
        });

    let oldestMessage = null;
    if (clientMessagesLastEvaluatedKey) {
      oldestMessage = Object.values(messages)
          .reduce((oldest, item) => {
            return new Date(item.createdAt) < new Date(oldest.createdAt) ? item : oldest;
          });
    }

    const logsFilter = Object.values(clientLogs)
        .filter((log) => {
          if (corType['LOGS']) {
            // limit logs shows to the oldest message
            if (oldestMessage && new Date(oldestMessage.createdAt) > new Date(log.createdAt) ) {
              return false;
            }

            return true;
          }
        });

    const messagesAndlogs = [
      ...(messagesFilter.map((e) => {
        return {...e, type: 'MESSAGE'};
      })),
      ...(logsFilter.map((e) => {
        return {...e, type: 'LOGS'};
      })),
    ];

    const sortedMessages = messagesAndlogs.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);

      if (sortDir === 'DESC') {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    });

    return sortedMessages;
  }, [messages, clientLogs, sortDir, corType]);

  const messagesToDisplay = messagesToDisplayCaluclator();

  const moreMessages = clientMessagesLoading || clientLogsLoading;
  const showLoadMoreButton =
    (clientMessagesLastEvaluatedKey && !clientMessagesLoading) ||
    (clientLogsLastEvaluatedKey && !clientLogsLoading);

  return (
    <Grid container>
      <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 1 : 2}}>
        <Stack
          sx={{
            pt: 1,
            pb: 2,
          }}
        >
          {
            messagesToDisplay.map((message, index) => {
              if (message.type === 'MESSAGE') {
                return (
                  <Box
                    key={message.messageRn}
                  >
                    <MessageFeedBox
                      message={message}
                      clientBackend={clientBackend}
                    />
                  </Box>
                );
              } else if (message.type === 'LOGS') {
                return (
                  <Box
                    key={message.clientLogRn}
                  >
                    <LogFeedBox
                      log={message}
                      clientBackend={clientBackend}
                    />
                  </Box>
                );
              }
              return null;
            })
          }
        </Stack>
      </Grid>
      {
        moreMessages &&
          <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
            <CircularProgress/>
          </Grid>
      }
      {
        showLoadMoreButton &&
        <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
          <Button
            color={'primary'}
            onClick={loadMoreMessages}
          >
            <Translate expression={'client.ClientDetail.Correspondance.Messages.LoadMore'} />
          </Button>
        </Grid>
      }
    </Grid>
  );
};
CorrespondanceFeed.propTypes = {
  clientRn: PropTypes.string.isRequired,

  // props for MessageFeedBox
  clientMessages: PropTypes.object.isRequired,
  clientLogs: PropTypes.object.isRequired,

  clientMessagesLoading: PropTypes.bool.isRequired,
  clientMessagesLastEvaluatedKey: PropTypes.string,

  clientLogsLoading: PropTypes.bool.isRequired,
  clientLogsLastEvaluatedKey: PropTypes.string,

  sortDir: PropTypes.string.isRequired,
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
  }).isRequired,

  clientBackend: PropTypes.object.isRequired,

};

export default React.memo(CorrespondanceFeed);
